import { createFileRoute } from "@tanstack/react-router";
import SiteGroundHosting from "@/pages/SiteGroundHosting";

export const Route = createFileRoute("/siteground-hosting")({
  component: SiteGroundHosting,
});
